module.exports = __webpack_public_path__ + "static/media/vintage_leather_strap_dark_brown_full_stitch.9f7b28b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vintage_leather_strap_dark_brown_full_stitch.png
// module id = 125
// module chunks = 0